import { createContext, useContext as useContextOrigin } from 'react';

export interface IModalContext {
  containerClassName: string;
}

export const ModalContext = createContext({
  containerClassName: '',
} as IModalContext);

export const useModalContext = (): IModalContext => {
  const {
    containerClassName,
  } = useContextOrigin(ModalContext);

  return {
    containerClassName,
  };
};
